import { useTheme } from '../../context/ThemeContext';
import { getThemeClasses } from '../../utils/theme';

const Footer = ({ variant = 'default' }) => {
  const { isDarkMode } = useTheme();
  const theme = getThemeClasses(isDarkMode);

  return (
    <footer className={`${theme.bgSecondary} border-t ${theme.border} py-4 mt-auto`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <p className={`text-xs ${theme.textMuted}`}>
            A <span className="font-semibold">CATHEXIS Labs</span> Production
          </p>
          <p className={`text-xs ${theme.textMuted}`}>
            © 2025 All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
